import { useMemo } from "react";

import { useLoc } from "../lib/hooks";
import { isEmpty } from "../lib/is-empty";
import { LocalizationOptions } from "../lib/localization";

declare type PlaceholderType = "unnamed" | "unspecified" | "untitled";
type ValuePlaceholderProps = {
  value: React.ReactNode;
  valueRender?: React.ReactNode;
  placeholder?: React.ReactNode;
  type?: PlaceholderType;
  className?: string;
  placeholderClassname?: string;
  locOpts?: LocalizationOptions;
};

export const ValuePlaceholder: React.FC<ValuePlaceholderProps> = ({
  value,
  valueRender,
  type = "unnamed",
  placeholder: _placeholder,
  className,
  placeholderClassname,
  locOpts,
}) => {
  const loc = useLoc();

  const placeholder = useMemo<React.ReactNode>(() => {
    if (_placeholder !== undefined) return _placeholder;
    switch (type) {
      case "unnamed":
        return loc.word("Global.unnamed", locOpts);
      case "untitled":
        return loc.word("Global.untitled", locOpts);
      case "unspecified":
        return loc.word("Global.unspecified", locOpts);
      default:
        return null;
    }
  }, [_placeholder, loc, locOpts, type]);

  return (
    <span className={className}>
      {isEmpty(value) ? (
        <span className={placeholderClassname}>{placeholder}</span>
      ) : (
        (valueRender ?? value)
      )}
    </span>
  );
};
